import { useState, useEffect, useRef } from 'react';

function useSocketOnline(player) {
  const [online, setOnline] = useState(navigator.onLine);
  const onlineRef = useRef(navigator.onLine);

  useEffect(() => {
    if (!player) {
      return undefined;
    }

    const handleConnect = () => {
      setOnline(true);
      onlineRef.current = true;
    };
    const handleDisconnect = () => {
      setOnline(false);
      onlineRef.current = false;
    };

    player.on('socket:connect', handleConnect);
    player.on('socket:disconnect', handleDisconnect);

    return undefined;
  }, [player]);

  useEffect(() => {
    const handleOffline = () => {
      setOnline(false);
      onlineRef.current = false;
    };

    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { online, onlineRef };
}

export default useSocketOnline;
